package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.Finance_category
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class FinanceCategoryRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Finance_category>> =
        db.financeCategoryQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeByType(type: String): Flow<List<Finance_category>> =
        db.financeCategoryQueries.selectByType(type).asFlow().mapToList(Dispatchers.Default)

    suspend fun create(
        name: String,
        type: String,
        icon: String,
        color: String,
        isDefault: Boolean = false,
        orderIndex: Long = 0,
        id: String = newId("fc"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.financeCategoryQueries.insert(
            id, name, type, icon, color, if (isDefault) 1L else 0L, orderIndex, now, now,
        )
        id
    }

    suspend fun update(
        id: String, name: String, type: String, icon: String, color: String, orderIndex: Long,
    ) = withContext(Dispatchers.Default) {
        db.financeCategoryQueries.update(name, type, icon, color, orderIndex, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.financeCategoryQueries.softDelete(now, now, id)
    }
}
